import GameCarousel from './GameCarousel';

const casinoGames = [
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/8112223af83f34457cfdb42511f4956b.png', alt: 'Dragon Tiger' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/f1ba247bdef6f86f6270e3c3fe83c154.png', alt: 'Bulgaria Roulette' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/aa16f835eb20768e69d7522ba3a6b8c9.png', alt: 'Lucky 6 Roulette' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/e43c67260c31b2c5794826a267d90267.png', alt: 'Spanish Roulette' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/1aadc3c26b9421d5b298361a91e32cbd.png', alt: 'Speed Baccarat' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/bcde75a1f6fefa2be8bc0995f5833366.png', alt: 'Mega Baccarat' },
  { src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/58ee1c471753c43db496415039f1d71b.png', alt: 'Venice Blackjack' },
];

const checkItems = [
  'High Level Of Security',
  'Bringing Reality To Vision',
  'Fantasy Bonus',
  'Anytime, Anywhere at PNGGO',
];

export default function LiveCasinoSection() {
  return (
    <section className="bg-[#111] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 lg:gap-12">
          {/* Left content — below hero image on mobile */}
          <div className="flex-1 w-full order-2 lg:order-1">
            <p className="text-[#B80E28] text-xs font-semibold tracking-widest uppercase mb-2">
              Real-Time Gaming Experience
            </p>
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-5">
              Live Casino Papua New Guinea
            </h2>
            <ul className="flex flex-col gap-3 mb-5">
              {checkItems.map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-white/80 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center bg-[#B80E28]/20 rounded-full flex-shrink-0">
                    <i className="fas fa-check text-[#B80E28] text-xs"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
            <p className="text-white/60 text-sm leading-7 mb-6">
              Playing live casino with PNGGO offers a myriad of advantages that enhance the overall gaming experience. Live casino games are run by professional dealers who ensure fair and transparent gameplay. With PNGGO&apos;s extensive selection of live casino games, players in Papua New Guinea can enjoy the thrill and excitement of traditional casino games from the comfort of their own home.
            </p>
            <div className="mb-6 px-5">
              <GameCarousel images={casinoGames} />
            </div>
            <a
              href="https://pnggo.bet/RFLANDINGPAGEPNG"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#B80E28] text-white font-semibold px-7 py-3 rounded-full hover:bg-[#9a0b21] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              PLAY NOW <i className="fas fa-chevron-right text-xs"></i>
            </a>
          </div>

          {/* Right image — top on mobile */}
          <div className="flex-1 w-full flex justify-center order-1 lg:order-2">
            <img
              src="https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/b6ce676382f8040087938acf22157536.png"
              alt="New Casino Games - Latest Online Casino Releases"
              className="mx-auto h-auto w-auto max-h-[210px] max-w-[210px] object-contain sm:max-h-[300px] sm:max-w-xs md:max-h-none md:max-w-sm"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
